import { getAttributeOrThrow, qsaRequired, qsRequired, targetRequired } from '@/scripts/core/global'
import { ProductFormGeneric } from '@/scripts/product-form-context/ProductFormGeneric'

export class ProductSubscribe extends ProductFormGeneric {
	static htmlSelector = 'product-subscribe'
	frequencyOptions: NodeListOf<HTMLButtonElement>
	frequencyOptionGroups: NodeListOf<HTMLElement>
	subscribeInput: HTMLInputElement
	oneTimeInput: HTMLInputElement
	tempPrice: String

	constructor() {
		super()
		this.frequencyOptions = qsaRequired<HTMLButtonElement>('[skio-frequency-option]', this)
		this.frequencyOptionGroups = qsaRequired('[data-variant-frequency-options]')
		this.subscribeInput = qsRequired<HTMLInputElement>("[name='selling_plan'][subscription]", this)
		this.oneTimeInput = qsRequired<HTMLInputElement>("[name='selling_plan'][one-time]", this)
		this.frequencyOptions.forEach((option) => {
			option.addEventListener('click', this.selectFrequency.bind(this))
		})
		this.subscribeInput.addEventListener('click', (_: Event) => {
			this.getContext().toggleSellingPlan(true)
		})
		this.oneTimeInput.addEventListener('click', (_: Event) => {
			this.getContext().toggleSellingPlan(false)
		})
		this.tempPrice = ''
	}

	updateVariantFrequencyOptions(variantId: number | string) {
		this.frequencyOptionGroups.forEach(el => {
			const groupVariantId = getAttributeOrThrow('data-variant-frequency-options', el)
			if (`${variantId}` === groupVariantId) {
				el.classList.add('active')
			} else {
				el.classList.remove('active')
			}
		})
	}

	updateVariantPrices(
		variant: { name: string },
		price: string,
		subPrice: string,
		otpComparePrice?: string,
		subComparePrice?: string
	) {
		// DOM needs to update all price elements
		// data-price-otp
		// data-price-recurring
		// data-price-otp-tooltip
		// data-price-sub-tooltip
		// Target the price node specifically ([data-price-current]) rather than the first
		// span, which is now a visually-hidden "Sale price" label on discounted variants.
		const priceOtp = this.querySelector('[data-price-otp] [data-price-current]')
		if (priceOtp && price) {
			priceOtp.innerHTML = price
		}
		// Strikethrough "was" price — rendered by Liquid but otherwise left stale on variant change.
		const priceOtpCompare = this.querySelector('[data-price-otp] s')
		if (priceOtpCompare && otpComparePrice) {
			priceOtpCompare.innerHTML = otpComparePrice
		}
		const priceSub = this.querySelector('[data-price-recurring] [data-price-current]')
		if (priceSub && subPrice) {
			priceSub.innerHTML = subPrice
		}
		const priceSubCompare = this.querySelector('[data-price-recurring] s')
		if (priceSubCompare && subComparePrice) {
			priceSubCompare.innerHTML = subComparePrice
		}

		
		const tooltipPriceOtp = this.querySelector('[data-price-otp-tooltip]')
		const tooltipPriceSub = this.querySelector('[data-price-sub-tooltip]')
		if (variant.name.includes('Super Saturated') && !variant.name.includes('Refill')) {
			if (tooltipPriceOtp && price) {
				tooltipPriceOtp.innerHTML = `- ${subPrice}`
			}
			if (tooltipPriceSub && this.tempPrice) {
				tooltipPriceSub.innerHTML = `${this.tempPrice}`
			}
		} else {
			if (tooltipPriceOtp) {
				tooltipPriceOtp.innerHTML = ''
			}
			if (tooltipPriceSub) {
				if (this.tempPrice === '') {
					this.tempPrice = tooltipPriceSub.innerHTML
				}
				tooltipPriceSub.innerHTML = ''
			}
		}

		// update tooltip message
		// .product-subscribe__item__text - check for check for serum replace with refill
		// .product-subscribe__item__subtext - if serum we need to remove text all together
		if (variant.name.includes('Super Saturated - Refill')) {
			const tooltipTitles = this.querySelectorAll('.product-subscribe__item__text')
			tooltipTitles.forEach(el => {
				
				if (el.innerHTML.includes('Serum')) {
					el.innerHTML = '1 x Super Saturated Refill'
				}
			})

			const tooltipSubTitles = this.querySelectorAll('.product-subscribe__item__subtext')
			tooltipSubTitles.forEach(el => {
				if (el.innerHTML.includes('with reusable pump')) {
					el.innerHTML = 'without reusable pump'
				}
			})
			// tooltip
		} else if (variant.name.includes('Super Saturated')) {
			const tooltipTitles = this.querySelectorAll('.product-subscribe__item__text')
			let changed = false
			tooltipTitles.forEach(el => {
				if (el.innerHTML.includes('Refill') && !changed) {
					el.innerHTML = '1 x Super Saturated Serum'
					changed = true
				}
			})

			const tooltipSubTitles = this.querySelectorAll('.product-subscribe__item__subtext')
			tooltipSubTitles.forEach(el => {
				if (el.innerHTML.includes('without reusable pump')) {
					el.innerHTML = 'with reusable pump'
				}
			})
		}

	}

	selectFrequency(event: Event) {
		const target = targetRequired(event)
		const frequency = parseInt(getAttributeOrThrow('skio-frequency-option', target))
		this.getContext().updateSellingPlanFrequency(frequency, target.innerHTML)
	}
}
